<template>
  <div class="holder">
    <span v-if="!loggedIn">
      <v-btn
        :small="xs_only"
        class="mr-2"
        rounded
        dense
        dark
        v-on:click="open_login_dialog = true"
      >
        <v-icon class="pr-2">mdi-account</v-icon>
        {{ $t("menu.login") }}
      </v-btn>
    </span>
    <span v-if="loggedIn">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :small="xs_only"
            rounded
            dark
            class="major--text"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-account</v-icon>
            <span class="pr-1 pl-1">{{ userName }}</span>
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-subheader>{{ userName }}</v-subheader>
          <v-subheader v-if="!isApplicant">
            (Logout เจ้าหน้าที่ ที่ Web สำนักทะเบียน)
            <v-btn
              outlined
              dense
              x-small
              fab
              class="ml-2"
              @click="open_login_dialog = true"
            >!</v-btn>
          </v-subheader>
          <v-list-item
            link
            v-on:click="logout()"
            v-show="isApplicant"
          >
            <v-list-item-action>
              <v-icon class="red--text"> mdi-logout-variant </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="red--text"> Logout </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </span>
  </div>
</template>

<script>
import { createHelpers } from "vuex-map-fields";

const { mapFields: paramsFields } = createHelpers({
  getterType: "params/getField",
  mutationType: "params/updateField",
});
export default {
  computed: {
    ...paramsFields({
      open_login_dialog: "open_login_dialog",
    }),
    userName() {
      if (this.$store.state.auth.user) {
        if (this.$store.state.auth.user.admission.status) {
          if (this.$store.state.auth.user.admission.STUDENT_FNAME_EN === "")
            return this.$t("app_bar.user");
          return this.$store.state.auth.user.admission.STUDENT_FNAME_EN;
        } else if (this.$store.state.auth.user.delegated_officer.status) {
          return this.$store.state.auth.user.delegated_officer.e_name;
        }
      }
      return "";
    },
    isApplicant() {
      return (
        this.$store.state.auth.user &&
        this.$store.state.auth.user.admission.status
      );
    },
    xs_only() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    loggedIn() {
      return this.$store.state.auth.user !== null;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
    },
  },
};
</script>

<style lang="scss" scoped>
.holder {
  margin-right: 10px;
}
</style>
